module.exports = __webpack_public_path__ + "6345afaa8bbb5925d5e5eccade169a14.png";